import { Vibrant } from "@vibrant/core";
import { Vibrant as Vibrant2 } from "@vibrant/core";
Vibrant.DefaultOpts.quantizer = "mmcq";
Vibrant.DefaultOpts.generators = ["default"];
Vibrant.DefaultOpts.filters = ["default"];
export {
  Vibrant2 as Vibrant
};
//# sourceMappingURL=config.js.map
